import Cookies from 'js-cookie';
import setUserProperties from '@alltrails/amplitude/utils/setUserProperties';
import {
  BROWSER_ID_COOKIE_NAME as FACEBOOK_BROWSER_ID_COOKIE_NAME,
  CLICK_ID_COOKIE_NAME as FACEBOOK_CLICK_ID_COOKIE_NAME
} from '@alltrails/core/utils/marketingTracking/facebook';
import { canSetMarketingCookiesForConsent } from '@alltrails/core/utils/marketingTracking/osanoConsent';
import { CLICK_ID_COOKIE_NAME as REDDIT_CLICK_ID_COOKIE_NAME } from '@alltrails/core/utils/marketingTracking/reddit';
import type OsanoConsentObject from '@alltrails/types/OsanoConsentObject';

/**
 * Amplitude user property name -> the marketing/attribution cookie its value comes from.
 */
const MARKETING_COOKIE_BY_USER_PROPERTY = {
  cid: '_ga',
  epik: '_epik',
  fbc: FACEBOOK_CLICK_ID_COOKIE_NAME,
  fbp: FACEBOOK_BROWSER_ID_COOKIE_NAME,
  irclickid: 'irclickid',
  irclickid_expiration: 'irclickid_expiration',
  irmpgroupname: 'irmpgroupname',
  rdt_cid: REDDIT_CLICK_ID_COOKIE_NAME,
  rdt_uuid: '_rdt_uuid',
  tinuiti_fpc: 'at_tinuitifpc'
} as const;

export const getMarketingCookieUserProperties = (): Record<string, string> =>
  Object.entries(MARKETING_COOKIE_BY_USER_PROPERTY).reduce<Record<string, string>>((properties, [userProperty, cookieName]) => {
    const value = Cookies.get(cookieName);

    if (value) {
      properties[userProperty] = value;
    }

    return properties;
  }, {});

/**
 * Amplitude counterpart to `setMarketingCookiesClientSide`: mirrors the marketing cookies into
 * Amplitude user properties once Osano reports a consent decision.
 *
 * @param osanoConsentObject - Consent as reported by the `osano-cm-initialized`/`-consent-saved` event.
 */
export const setMarketingUserPropertiesClientSide = (osanoConsentObject: OsanoConsentObject): void => {
  if (!canSetMarketingCookiesForConsent(osanoConsentObject)) {
    return;
  }

  const userProperties = getMarketingCookieUserProperties();

  if (Object.keys(userProperties).length === 0) {
    return;
  }

  setUserProperties(userProperties);
};
